module.exports = __webpack_public_path__ + "img/pin.6051a7e7.png";